import { Outlet } from 'react-router';
import { Wordmark } from '@/components/brand';
import { LegalLinks } from '@/features/legal/legal-links';

/** Painel institucional à esquerda (só em telas largas) e formulário à direita. */
export function AuthLayout() {
  return (
    <div className="grid min-h-dvh lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)]">
      <aside className="relative hidden flex-col justify-between overflow-hidden bg-sidebar p-12 text-sidebar-foreground lg:flex">
        <Wordmark className="text-sidebar-foreground" />
        <div className="max-w-md">
          <p className="font-display text-[2.6rem] leading-[1.08] font-semibold tracking-tight text-white dark:text-sidebar-foreground">
            A loja inteira numa mesa organizada.
          </p>
          <p className="mt-5 max-w-sm text-base text-sidebar-muted">
            Peças, estoque, consignação, caixa e loja virtual no mesmo lugar, com cada pessoa vendo só o que o seu papel permite.
          </p>
        </div>
        <p className="text-sm text-sidebar-muted">Dados de clientes protegidos, com registro de quem acessou o quê.</p>
      </aside>
      <main className="flex min-h-dvh flex-col px-5 py-8 sm:px-10">
        <div className="lg:hidden">
          <Wordmark />
        </div>
        <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-10">
          <Outlet />
        </div>
        <LegalLinks className="mx-auto w-full max-w-sm justify-center text-muted-foreground" linkClassName="inline-flex min-h-8 items-center" />
      </main>
    </div>
  );
}
